const API_TIME_OUT = 30

export { API_TIME_OUT }
